import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CreditCardsFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.5 5.7C1.5 4.48498 2.47352 3.5 3.67442 3.5H17.3256C18.2846 3.5 19.0986 4.12816 19.3876 5H6.6748C5.05197 5 3.69143 6.05292 3.19819 7.5H1.5V5.7ZM3 17.3921V8.7H1.5V15.3C1.5 16.2768 2.12925 17.105 3 17.3921Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.85165 7.5C5.23963 6.89796 5.91109 6.5 6.67442 6.5H19.5H20.3256C21.5265 6.5 22.5 7.48498 22.5 8.7V10.5H19.5H4.5V8.7C4.5 8.25728 4.62925 7.84511 4.85165 7.5Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.5 11.7H19.5H22.5V18.3C22.5 19.515 21.5265 20.5 20.3256 20.5H6.67442C5.47352 20.5 4.5 19.515 4.5 18.3V17.5V11.7ZM18.7442 16.1C18.9464 16.1 19.125 16.2024 19.2321 16.3588C19.2984 16.4557 19.3372 16.5733 19.3372 16.7C19.3372 17.0314 19.0717 17.3 18.7442 17.3H18.2327H15.9767C15.6492 17.3 15.3837 17.0314 15.3837 16.7C15.3837 16.3686 15.6492 16.1 15.9767 16.1H18.7442ZM12.4186 16.1C12.0911 16.1 11.8256 16.3686 11.8256 16.7C11.8256 17.0314 12.0911 17.3 12.4186 17.3L12.9297 17.2998H13.0938L13.6047 17.3C13.9322 17.3 14.1977 17.0314 14.1977 16.7C14.1977 16.3686 13.9322 16.1 13.6047 16.1L13.0928 16.0996H12.9307L12.4186 16.1Z"
				fill="currentColor"
			/>
		</svg>
	);
}

CreditCardsFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CreditCardsFilledIcon;
